import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/tailwind.css";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";

import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";
import titleMixin from './utils/titleMixin'

Vue.mixin(titleMixin)

//Vuesax styles
Vue.use(Vuesax, {
  // options here
  rtl: false,
});
import VueDragscroll from "vue-dragscroll";
Vue.use(VueDragscroll);

//import { debounce } from "debounce";
//Vue.use(debounce);

/* VeeValidate */
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid",
  },
  fieldsBagName: "vvFields",
});

/* VueCtkDateTimePicker */
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import Lottie from "vue-lottie";
Vue.component("lottie", Lottie);

import VueTelInputVuetify from "vue-tel-input-vuetify/lib";

Vue.use(VueTelInputVuetify, { vuetify });

import draggable from "vuedraggable";
Vue.component("draggable", draggable);

/* vue-moment */
const moment = require("moment");
require("moment/locale/es");
Vue.use(require("vue-moment"), {
  moment,
});

import VueSignalR from "@latelier/vue-signalr";
Vue.use(VueSignalR, "https://www.ausa.com.mx/apiwhatsapp/message-hub");

/* /vue2-masonry-wall */
// import MasonryWall from "@yeger/vue2-masonry-wall";
// Vue.use(MasonryWall);

/* vue-navigation-bar */
import VueNavigationBar from "vue-navigation-bar";
import "vue-navigation-bar/dist/vue-navigation-bar.css";
Vue.component("vue-navigation-bar", VueNavigationBar);

/* Vue-multiselect */
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import IdleVue from "idle-vue";

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAlMQFjdtJRXoGZv0KUUDrg9cHwsCOh3NA",
  },
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAlMQFjdtJRXoGZv0KUUDrg9cHwsCOh3NA",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 3000000,
});

Vue.component("multiselect", Multiselect);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

import VueLazyLoad from "vue-lazyload";
Vue.use(VueLazyLoad);

import "vue-pdf-app/dist/icons/main.css";
import VuePdfApp from "vue-pdf-app";
Vue.component("vue-pdf-app", VuePdfApp);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
  onIdle() {
    console.log("Session Expired");
  },
}).$mount("#app");
